// Balloon colors
export const BALLOON_COLORS = [
  { 
    main: 'rgb(239, 68, 68)',     // red
    light: 'rgb(252, 165, 165)',
    dark: 'rgb(185, 28, 28)',
    text: 'white'
  },
  { 
    main: 'rgb(59, 130, 246)',    // blue
    light: 'rgb(147, 197, 253)',
    dark: 'rgb(30, 64, 175)',
    text: 'white'
  },
  { 
    main: 'rgb(16, 185, 129)',    // green
    light: 'rgb(110, 231, 183)',
    dark: 'rgb(4, 120, 87)',
    text: 'white'
  },
  { 
    main: 'rgb(245, 158, 11)',    // yellow
    light: 'rgb(252, 211, 77)',
    dark: 'rgb(180, 83, 9)',
    text: 'black'
  },
  { 
    main: 'rgb(139, 92, 246)',    // purple
    light: 'rgb(196, 181, 253)',
    dark: 'rgb(91, 33, 182)',
    text: 'white'
  },
  { 
    main: 'rgb(236, 72, 153)',    // pink
    light: 'rgb(249, 168, 212)',
    dark: 'rgb(190, 24, 93)',
    text: 'white'
  },
];

// Sample STEM questions
export const QUESTIONS = [
  {
    id: 1,
    text: "What is the formula for the area of a circle?",
    options: ["A = πr²", "A = 2πr", "A = πd", "A = r²"],
    correctAnswer: 0,
    category: "math",
    difficulty: "easy",
    explanation: "The area of a circle is calculated using the formula A = πr², where r is the radius of the circle."
  },
  {
    id: 2,
    text: "Which planet is known as the Red Planet?",
    options: ["Venus", "Mars", "Jupiter", "Mercury"],
    correctAnswer: 1,
    category: "science",
    difficulty: "easy",
    explanation: "Mars is known as the Red Planet due to its reddish appearance, which comes from iron oxide (rust) on its surface."
  },
  {
    id: 3,
    text: "What does CPU stand for in computing?",
    options: ["Central Processing Unit", "Computer Personal Unit", "Central Program Utility", "Control Processing Unit"],
    correctAnswer: 0,
    category: "technology",
    difficulty: "easy",
    explanation: "CPU stands for Central Processing Unit, the primary component of a computer that performs most of the processing."
  },
  {
    id: 4,
    text: "Which of these is NOT a simple machine?",
    options: ["Lever", "Pulley", "Generator", "Inclined plane"],
    correctAnswer: 2,
    category: "engineering",
    difficulty: "medium",
    explanation: "A generator is not a simple machine. The six simple machines are: lever, wheel and axle, pulley, inclined plane, wedge, and screw."
  },
  {
    id: 5,
    text: "What is the chemical formula for water?",
    options: ["CO2", "H2O", "O2", "H2O2"],
    correctAnswer: 1,
    category: "science",
    difficulty: "easy",
    explanation: "Water has the chemical formula H2O, representing two hydrogen atoms bonded to one oxygen atom."
  },
  {
    id: 6,
    text: "What is 3² × 4³?",
    options: ["144", "288", "432", "576"],
    correctAnswer: 3,
    category: "math",
    difficulty: "medium",
    explanation: "3² = 9 and 4³ = 64, so 3² × 4³ = 9 × 64 = 576"
  },
  {
    id: 7,
    text: "Which programming language is often used for artificial intelligence and data science?",
    options: ["Java", "C++", "Python", "Ruby"],
    correctAnswer: 2,
    category: "technology",
    difficulty: "medium",
    explanation: "Python is widely used in artificial intelligence and data science due to its simplicity and powerful libraries like TensorFlow and PyTorch."
  },
  {
    id: 8,
    text: "What does HTML stand for?",
    options: ["Hyper Text Markup Language", "High Tech Machine Learning", "Hyper Transfer Markup Logic", "Home Tool Markup Language"],
    correctAnswer: 0,
    category: "technology",
    difficulty: "easy",
    explanation: "HTML stands for Hyper Text Markup Language, which is the standard markup language for creating web pages."
  },
  {
    id: 9,
    text: "Which force keeps planets orbiting around the Sun?",
    options: ["Magnetic force", "Gravitational force", "Centrifugal force", "Electrical force"],
    correctAnswer: 1,
    category: "science",
    difficulty: "easy",
    explanation: "Gravitational force keeps planets in orbit around the Sun. This is described by Newton's law of universal gravitation."
  },
  {
    id: 10,
    text: "Which of these materials is the best electrical conductor?",
    options: ["Rubber", "Wood", "Silver", "Glass"],
    correctAnswer: 2,
    category: "engineering",
    difficulty: "medium",
    explanation: "Silver is the best electrical conductor among these options and actually has the highest electrical conductivity of all metals."
  },
  {
    id: 11,
    text: "What is the value of sin(90°)?",
    options: ["0", "0.5", "1", "2"],
    correctAnswer: 2,
    category: "math",
    difficulty: "medium",
    explanation: "The sine of 90 degrees equals 1."
  },
  {
    id: 12,
    text: "Which of the following is a renewable energy source?",
    options: ["Coal", "Natural gas", "Solar power", "Petroleum"],
    correctAnswer: 2,
    category: "science",
    difficulty: "easy",
    explanation: "Solar power is a renewable energy source because sunlight is naturally replenished and virtually inexhaustible."
  },
  {
    id: 13,
    text: "Which data structure follows the Last In, First Out (LIFO) principle?",
    options: ["Queue", "Stack", "Linked List", "Array"],
    correctAnswer: 1,
    category: "technology",
    difficulty: "medium",
    explanation: "A stack follows the Last In, First Out (LIFO) principle, where the last element added is the first one to be removed."
  },
  {
    id: 14,
    text: "What is the most abundant gas in Earth's atmosphere?",
    options: ["Oxygen", "Carbon Dioxide", "Nitrogen", "Hydrogen"],
    correctAnswer: 2,
    category: "science",
    difficulty: "easy",
    explanation: "Nitrogen makes up about 78% of Earth's atmosphere, making it the most abundant gas."
  },
  {
    id: 15,
    text: "Which element has the chemical symbol 'Fe'?",
    options: ["Iron", "Fluorine", "Fermium", "Francium"],
    correctAnswer: 0,
    category: "science",
    difficulty: "medium",
    explanation: "Fe is the chemical symbol for Iron, from its Latin name 'ferrum'."
  }
]; 